import { _ep0, _mw0, command } from "../commandBuilder";
import { UpdateEmailTemplate$ } from "../schemas/schemas_0";
export class UpdateEmailTemplateCommand extends command(_ep0, _mw0, "UpdateEmailTemplate", UpdateEmailTemplate$) {
}
